<template>
  <tr>
    <td class="expandable-column ts-w-3" :colspan="$parent.columnLength + 1">
      <slot />
    </td>
  </tr>
</template>

<script>
export default {
  name: 'ExpandableRow'
}
</script>
